<template>
  <v-dialog
    width="500"
    persistent
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card :loading="loading">
      <v-card-title>
        Cadastro de Conteúdo do youtube
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          :disabled="loading"
        >
          <v-text-field
            v-model="dataContent.name"
            :error-messages="formErrors.name"
            :rules="rulesName"
            label="Nome"
            @input="formErrors.name = ''"
          />

          <v-select
            v-model="dataContent.type"
            :error-messages="formErrors.type"
            :items="contentType"
            item-text="typeName"
            item-value="value"
            label="Tipo"
            @input="formErrors.type = ''"
          />

          <v-text-field
            v-model="dataContent.duration"
            type="number"
            :error-messages="formErrors.duration"
            label="Duração em segundos"
            @input="formErrors.duration = ''"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="primary"
          text
          @click="onCancel"
        >
          Fechar
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="save()"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import utils from '@/api/utils.js'
import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
  },
  mixins: [
    handlesServerValidation
  ],

  data: () => ({
    rulesName: [
      value => !!value || 'Nome é obrigatório.',
      value => (value && value.length >= 3) || 'Min 3 caracteres'
    ],
    dataContent: {
      name: undefined,
      type: 0,
      description: undefined
    },
    contentType: [],
    level: '',
    levels: [],
    saveSuccess: false,
    loading: false,
    topicId: null,
    difficulty: null,
    topicName: ''
  }),

  created () {
    this.fetchAll()
  },

  methods: {
    fetchAll () {
      this.contentType = utils.contentType()
    },

    validate () {
      return this.$refs.form.validate()
    },

    async save () {
      const validated = await this.validate()
      if (!validated) {
        return false
      }

      this.loading = true

      const data = {
        name: this.dataContent.name,
        type: this.dataContent.type,
        duration: this.dataContent.duration
      }

      try {
        const response = await this.$api.createMediaContent(data)
        this.onSubmit(response)
      } catch (e) {
        this.getErrors(e)
      }

      this.loading = false
    },
    onCancel () {
      this.$emit('resolve', false)
    },

    onSubmit (value) {
      this.$emit('resolve', value)
    }
  }
}
</script>
